<template>
  <v-dialog v-model="dialog" max-width="400" persistent scrollable>
    <template v-slot:activator="{ on }">
      <mf-button class="width-responsive" label="Desbloquear saldo" outlined :disabled="disabled" v-on:click.native="on.click" />
    </template>

    <v-card v-if="$permissions.havePagePermission('clientes/desbloquear-cashback')">
      <v-card-title class="d-flex justify-space-between">
        <span>Desbloquear saldo</span>
        <mf-icon style="cursor: pointer" @click="dialog = false">close</mf-icon>
      </v-card-title>
      <v-card-text
        >Tem certeza que deseja desbloquear o consumo de cashback do consumidor <b>{{ documentNo | cpfCnpj }}</b
        >? Você pode desbloquear a carteira sem consumir o saldo, então ele será redisponibilizado para o consumidor, ou desbloquear consumindo o saldo, então
        ele será debitado da carteira desse cliente.
      </v-card-text>

      <div class="d-flex flex-column justify-center" style="gap: 12px; padding: 0 24px 20px">
        <mf-button
          style="width: 100%"
          outlined
          text-transform="none"
          label="Desbloquear sem consumir saldo"
          :loading="loading"
          @click="unlockWallet"
        ></mf-button>
        <mf-button
          style="width: 100%"
          text-transform="none"
          label="Desbloquear consumindo saldo"
          :loading="loading"
          @click="unblockWalletAndConsumeBalance"
        ></mf-button>
      </div>
    </v-card>

    <v-card v-else>
      <v-card-title class="d-flex justify-center">
        <mf-icon x-large fill color="vermelho-d20">warning</mf-icon>
      </v-card-title>
      <v-card-text class="d-flex flex-column" style="gap: 12px">
        <span class="text-center cinza-d10-text" style="font-size: 20px; font-weight: bold">Ops! Você não possui permissão</span>
        <span class="cinza-0-text" style="font-size: 16px"
          >Você não possui permissão para realizar o desbloqueio de cashback de uma carteira. Fale com um superior para realizar essa ação ou conceder permissão
          para seu usuário.</span
        >
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <mf-button outlined text-transform="none" label="Fechar" @click="() => (dialog = false)"></mf-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { MUTATION_RELEASE_CASHBACK_BALANCE_LOCK, MUTATION_RELEASE_CASHBACK_BALANCE_LOCK_AND_CONSUME_BALANCE } from '@/modules/mobile/cashback/graphql'
import { MUTATION_RELEASE_ABSOLUTE_DISCOUNT_LOCK, MUTATION_RELEASE_ABSOLUTE_DISCOUNT_AND_CONSUME_LOCK } from '@/modules/industria/cashback/graphql'

export default {
  name: 'CashbackUnlockDialog',
  props: {
    documentNo: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    loading: false,
  }),
  computed: {
    hasCashbackModule() {
      return this.$getAllowedModules()['cashback']
    },
  },
  methods: {
    async unlockWallet() {
      this.loading = true
      try {
        if (this.hasCashbackModule) {
          await this.$apollo.mutate({
            mutation: MUTATION_RELEASE_CASHBACK_BALANCE_LOCK,
            variables: {
              document_no: this.documentNo,
            },
            context: {
              uri: this.$microservicesUrls['cashback'],
            },
          })
        } else {
          await this.$apollo.mutate({
            mutation: MUTATION_RELEASE_ABSOLUTE_DISCOUNT_LOCK,
            variables: {
              document_no: this.documentNo,
              type: 'nextbuycashback',
            },
            context: {
              uri: this.$microservicesUrls['cashback'],
            },
          })
        }
        this.$emit('cashbackUnlocked')
        this.dialog = false
      } catch (e) {
        this.$snackbar({ message: 'Erro ao ajustar cashback', snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
    },
    async unblockWalletAndConsumeBalance() {
      this.loading = true
      try {
        if (this.hasCashbackModule) {
          await this.$apollo.mutate({
            mutation: MUTATION_RELEASE_CASHBACK_BALANCE_LOCK_AND_CONSUME_BALANCE,
            variables: {
              document_no: this.documentNo,
            },
            context: {
              uri: this.$microservicesUrls['cashback'],
            },
          })
        } else {
          await this.$apollo.mutate({
            mutation: MUTATION_RELEASE_ABSOLUTE_DISCOUNT_AND_CONSUME_LOCK,
            variables: {
              document_no: this.documentNo,
              type: 'nextbuycashback',
            },
            context: {
              uri: this.$microservicesUrls['cashback'],
            },
          })
        }
        this.$emit('cashbackUnlocked')
        this.dialog = false
      } catch (e) {
        this.$snackbar({ message: 'Erro ao ajustar cashback', snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
.width-responsive {
  width: 100%;
}

.cinza-d10-text {
  color: $cinza-d10;
}

.cinza-0-text {
  color: $cinza-0;
}

@media screen and (min-width: 933px) {
  .width-responsive {
    width: 30%;
  }
}
</style>
